import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db.js";

export async function getPhotographerFromID(id){
    const photographer = await getPhotographer(id);

    return photographer;
}

export async function getMediasFromID(id){
    const medias = await getAllMediasForPhotographer(id);

    return medias;
}